import type { GetApiV1ThreeLetterCodePartnerAdminsClientsClientId200 } from '@fukuri-admins/apis/client/gen/model';
import { groupCustomFieldValuesByLabelAsArray } from '~/utils/customFieldUtils';
import type { EditClientFormFieldValues } from '../schema';

type Args = {
  clientData: GetApiV1ThreeLetterCodePartnerAdminsClientsClientId200;
};

type IConvertToFormValues = (args: Args) => EditClientFormFieldValues;

/**
 * APIレスポンスからフォーム初期値に変換する（新版）
 *
 * - prefecture.code（2桁コード文字列）を prefectureCode にマッピングする
 * - groupId は groups 配列の最初の id を文字列に変換する
 * - employeeCount: client.employee_count は `number | null | undefined`。
 *   null の場合に `0` を補完すると「利用予定者数が実際に0人」と区別が付かなくなるため、
 *   CreateClientForm の初期値（未入力時 undefined）に揃えて `undefined` に変換する
 *   （number 型フィールドへの undefined 代入は本プロジェクトの tsconfig（strict: false）で許容されている）
 */
export const convertToFormValues: IConvertToFormValues = ({ clientData }) => {
  const { client } = clientData;

  return {
    name: client.name ?? '',
    nameKana: client.name_kana ?? '',
    representativeName: client.representative_name ?? '',
    corporateNumber: client.corporate_number ?? '',
    externalClientId: client.external_client_id ?? '',
    postalCode: client.postal_code ?? '',
    prefectureCode: client.prefecture?.code ?? '',
    city: client.city ?? '',
    streetAddress: client.street_address ?? '',
    employeeCount: client.employee_count ?? undefined,
    partnerBranchId: client.partner_branch?.id ? String(client.partner_branch.id) : '',
    clientFeatureFlags:
      client.client_feature_flags?.filter(flag => flag.enabled).map(flag => flag.feature_key) ?? [],
    contactPersonName: client.contact_person_name ?? '',
    contactPersonNameKana: client.contact_person_name_kana ?? '',
    contactPersonEmail: client.contact_person_email ?? '',
    contactPersonPhone: client.contact_person_phone ?? '',
    contactPreferredTime: client.contact_preferred_time ?? '',
    billingContactName: client.billing_contact_name ?? '',
    billingContactNameKana: client.billing_contact_name_kana ?? '',
    billingEmail: client.billing_email ?? '',
    groupId: client.groups?.[0]?.id ? String(client.groups[0].id) : '',
    customFields: client.custom_field_values
      ? groupCustomFieldValuesByLabelAsArray(client.custom_field_values)
      : undefined,
  };
};
